import React from 'react';
import AuthService from './authService.js';
import UserLinkItem from '../Domain/UserLinkItem.js';
import serviceHelper from '../Helpers/serviceHelper.js';
import SearchParams from '../Elements/SearchParams';
import UserLinkSearchParams from '../Elements/UserLinkSearchParams';

class UserLinkService extends React.Component
{

  static GetUserLinks (orderById, orderDir, pageNumber, numberOfElements, searchItem)
  {
    // console.log('Fetching user links with parameters: ', { orderById, orderDir, pageNumber, numberOfElements, searchItem });
    const searchParams = new SearchParams(searchItem, UserLinkSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const authService = AuthService.getInstance();
    const url = `/api/UserLink/GetAllBySearchingAsync?&searchParams=${searchParams.serializeForBackendCall()}`;
    // console.log('Constructed URL for fetching user links: ', url);
    return authService.CallBackendFunction(url);
  }

  static ConvertDBItemList (items)
  {
    const convertedItems = [];

    if (items !== null)
    {
      items.forEach((item) =>
      {
        const newItem = new UserLinkItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static UpsertUserLink (item)
  {
    item = serviceHelper.ConvertAllPropertyToString(item);
    if (item.UserlinkId === '')
    {
      return AuthService.getInstance().CallBackendFunctionPost('/api/UserLink/PostUserLinkAsync', JSON.stringify(item));
    }

    return AuthService.getInstance().CallBackendFunctionPut('/api/UserLink/EditUserLinkAsync', JSON.stringify(item));
  }

  static DeleteUserLink (id)
  {
    const url = `/api/UserLink/DeleteUserLinkAsync/${id}`;
    return AuthService.getInstance().CallBackendFunctionDelete(url);
  }
}

export default UserLinkService;
